import type { StateDeclarationFn } from 'controller/types';

export default [
  require('./group-list.route').default,
  require('./groups-page.route').default,
] as StateDeclarationFn[];
